// Shared types/constants for the ReportBuilder + extracted card components.
// Web Speech API types aren't in the standard TS lib so we define minimal
// shapes here. Lifted out of ReportBuilder.tsx during the 2026-05-01 split.

export interface SpeechRecognitionEvent extends Event {
  results: SpeechRecognitionResultList;
  resultIndex: number;
}
export interface SpeechRecognitionInstance extends EventTarget {
  continuous: boolean;
  interimResults: boolean;
  lang: string;
  start(): void;
  stop(): void;
  onresult: ((event: SpeechRecognitionEvent) => void) | null;
  onerror: ((event: Event) => void) | null;
  onend: (() => void) | null;
}

declare global {
  interface Window {
    SpeechRecognition?: new () => SpeechRecognitionInstance;
    webkitSpeechRecognition?: new () => SpeechRecognitionInstance;
  }
}

export const ItemTypes = {
  SECTION: 'section',
  ITEM: 'item',
};
